import type {PromotionCycleHistory} from '../../types';

import {Chip, Loading} from '@ds/components';
import historyEmptyState from 'assets/images/promotion-center/new/historyEmptyState.svg';
import Empty from 'common/empty/Empty';
import {getStatusChipProps} from 'common/status-chip/getStatusChipProps';
import InfiniteScroll from 'react-infinite-scroll-component';

const PROMOTION_CYCLE_STATE_LABELS: Record<string, string> = {
  waiting: 'در انتظار اجرا',
  inprogress: 'در حال اجرا',
  done: 'پایان یافته',
  refund: 'بازپس گرفته شده'
};

type PromotionHistoryProps = {
  history: PromotionCycleHistory;
  onLoadMore: () => void;
  onItemClick: (cycleId: string | number) => void;
};

const PromotionHistory: React.FC<PromotionHistoryProps> = ({history, onLoadMore, onItemClick}) => {
  const items = history.cycle ?? [];
  const totalItems = history.total_items ?? items.length;

  return (
    <section className="flex flex-col">
      <h2 className="mx-4 mt-4 mb-2 text-subtitle-md text-neutral-fg">تاریخچه</h2>
      {items.length > 0 ? (
        <InfiniteScroll
          dataLength={items.length}
          scrollableTarget="promotion-center-info"
          next={onLoadMore}
          hasMore={items.length < totalItems}
          loader={
            <div className="flex h-10 justify-center">
              <Loading size="medium" color="primary" />
            </div>
          }
          scrollThreshold={0.6}
        >
          <div className="flex flex-col">
            {items.map((item) => {
              const chipProps = getStatusChipProps(item.cycle_state);
              return (
                <button
                  type="button"
                  key={item.id}
                  className="flex w-full items-center justify-between gap-3 border-b border-gray-03 px-4 py-3 text-start focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange"
                  onClick={() => onItemClick(item.id)}
                >
                  <span className="flex min-w-0 flex-col">
                    <span className="text-body-sm-emphasis text-neutral-fg">{item.title}</span>
                    <span className="text-body-sm text-gray-07">{item.productCount} کالا</span>
                  </span>
                  <Chip
                    label={PROMOTION_CYCLE_STATE_LABELS[item.cycle_state] ?? item.cycle_state}
                    variant={chipProps.variant}
                    color={chipProps.color}
                    size="sm"
                    interactive={false}
                  />
                </button>
              );
            })}
          </div>
        </InfiniteScroll>
      ) : (
        <Empty illustration={historyEmptyState} className="gap-1 px-4 py-8 text-center">
          <div className="mt-9.75 flex flex-col gap-1">
            <p className="text-body-sm-emphasis text-neutral-fg">
              تا به حال در دوره تخفیف شرکت نکردید
            </p>
            <p className="text-body-sm text-gray-07">
              پس از پیوستن به دوره تخفیف می‌توانید تاریخچه دوره‌ها را مشاهده کنید.
            </p>
          </div>
        </Empty>
      )}
    </section>
  );
};

export default PromotionHistory;
